import React, { useEffect, useContext } from 'react'
import { VStack, Heading, Text, Box, useColorMode } from '@chakra-ui/react'
import { getTokens } from '../config/colorTokens'
import { motion, AnimatePresence } from 'framer-motion'
import Section from '../components/Section'
import Company from '../components/Experience/Company'
import { experience } from '../data/experience'
import Loader from '../components/Loader/Loader'
import loaderContext from '../context/loaderContext'
import SEOHead from "../components/SEOHead";
import { pageVariants, containerVariants, itemVariants, heroVariants } from '../config/animations'

const MotionVStack = motion(VStack)
const MotionBox = motion(Box)

const Experience = () => {
    const context = useContext(loaderContext)
    const { loading, setLoading } = context
    const { colorMode } = useColorMode()
    const t = getTokens(colorMode)

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 1500)
    }, [setLoading])
    return (
        <div>
            <SEOHead 
                title="Experience | Prasoon Soni"
                description="Professional experience of Prasoon Soni - Explore roles, responsibilities, and achievements across various companies and projects in software engineering."
                path="/experience"
            />
            <AnimatePresence>
                {loading ? <Loader key="loader" /> : <MotionVStack
                    key="content"
                    variants={pageVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    spacing={0}
                    w="100%"
                    minH="100vh"
                >
                <Section id="experience">
                    <VStack align="stretch" spacing={4} p={4}>
                        <MotionBox variants={heroVariants}>
                            <VStack align="start" spacing={3} mb={4}>
                                <Heading w="full">Experience</Heading>
                                <Text
                                    fontSize={{ base: "md", md: "lg" }}
                                    color={t.textSubtle}
                                    fontWeight="light"
                                    maxW="2xl"
                                >
                                    Engineering impact across systems and teams.
                                </Text>
                                <Box
                                    h="2px"
                                    w="60px"
                                    bgGradient={t.accentGradient}
                                    borderRadius="full"
                                    mt={1}
                                />
                            </VStack>
                        </MotionBox>
                        <MotionVStack
                            align="stretch"
                            spacing={4}
                            variants={containerVariants}
                        >
                            {experience.map((exp) => {
                                return (
                                    <Company
                                        key={exp.id}
                                        role={exp.role}
                                        company={exp.company}
                                        type={exp.type}
                                        location={exp.location}
                                        logo={exp.logo}
                                        date={exp.date}
                                        description={exp.description}
                                        link={exp.link}
                                        variants={itemVariants}
                                    />
                                )
                            })}
                        </MotionVStack>
                    </VStack>
                </Section>
                </MotionVStack>}
            </AnimatePresence>
        </div >
    )
}

export default Experience
